@if (_options && _options.series) {
  <highcharts-chart
    [Highcharts]="Highcharts"
    [options]="_options"
    [ngStyle]="{ display: 'block' }"
    [style.height.px]="height || 236"
    [style.min-width.px]="width || 236"
  ></highcharts-chart>
}
@if (showLegend && _options && _options.series) {
  <ea-charts-legend
    [options]="_options"
    [series]="_options.series[0].data"
    [showValues]="showLegendValues"
    [unity]="unity"
  ></ea-charts-legend>
}
